
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import componentModel from './componentModel.vue';
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";

    interface TitleData {
        text: string;
        icon: string;
        clickFun: string;
    } 

    interface State {
        isNoDefect: ComputedRef<boolean>; // 是否为无火烧无泡水无重大事故的车
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        isAccident: number; // 0不是事故车 1是事故车
        isFire: number; // 0不是事故车 1是事故车
        isWater: number; // 0不是事故车 1是事故车
        reportCode: string | null; 
        isCeilingLamp: ComputedRef<boolean>;
        isActive: boolean;
        opacityStyle: number;
        titleDataMajor: TitleData;
        titleDataFire: TitleData;
        titleDataWater: TitleData;
        clickData: object;
        isShowModel: boolean;
        bgCol: string;
        channelType: string;
        reportLevel: number;
        logoUrl: string;
        checkTitle: string;
    }

    export default defineComponent({
        name: "headTip",
        setup() {
            const {query} = useRoute();
            let state: State = reactive({
                isNoDefect: false as any,
                point: "N" as any,
                isAccident: 1,
                isFire: 1,
                isWater: 1,
                reportCode: '',
                isCeilingLamp: false as any,
                isActive: false,
                opacityStyle: 0,
                bgCol:'#ffffff',
                isShowModel: false,
                clickData: {},
                channelType: `${query.channelType}` || '',
                reportLevel: 0,
                logoUrl: '',
                checkTitle: '',
                titleDataMajor: {
                    text: '事故检测',
                    icon: 'shuoming.png',
                    clickFun: 'showRemind',
                    isShow: true,
                    modelCnt: [
                        '【事故检测标准】根据检测项目中是否出现凹陷、钣金修复、变形、更换、喷漆修复、切割等状态和出现以上状态的受损程度，来综合判断此车是否存在重大事故车风险。',
                        'prop_up_height',
                        '【重大事故认定标准】左右底大边、不可拆水箱框架、四个翼子板内衬、后围板、导水槽、行李箱封边、车顶边、车顶、两后翼子板存在切割，车身底板、行李箱底板、前后纵梁、前后减震器座、行李箱隔板、防火墙、左右A/B/C/D柱内侧存在钣金修复、严重变形、切割。 具体标准详见268V检测认证承诺书附件《268V检测认证标准》。'
                    ]
                },
                titleDataFire: {
                    text: '火烧检测',
                    icon: 'shuoming.png',
                    clickFun: 'showRemind',
                    isShow: true,
                    modelCnt: [
                        '【火烧检测标准】根据检测项目中是否出现烟熏、碳化、受热变形等状况，来判断是否有火烧车风险。',
                        'prop_up_height',
                        '【火烧车认定标准】减震器座、发动机舱、车身线束、发动机舱内管路、行李箱舱、存在烟熏、碳化、受热变形任一情况，即认定为火烧车。具体标准详见268V检测认证承诺书附件《268V检测认证标准》。'
                    ]
                },
                titleDataWater: {
                    text: '泡水检测',
                    icon: 'shuoming.png',
                    clickFun: 'showRemind',
                    isShow: true,
                    modelCnt: [
                        '【泡水检测标准】根据检测项目中是否出现泥沙、水印、锈蚀、霉斑等状态和受损程度来综合判断车辆是否有泡水风险。',
                        'prop_up_height',
                        '【泡水车认定标准】座椅滑轨、安全带、座椅座垫底部、车顶篷、行李箱、保险丝盒、发动机舱、点烟器、地胶（毯）、转向柱等发现有明显的泡水迹象（例如：含泥沙、水印、锈蚀、霉斑等情况）若存在以下三种或大于三种情况，即认定为泡水车。具体标准详见268V检测认证承诺书附件《268V检测认证标准》。',
                    ]
                }
            })
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            let isDisplay: ComputedRef<{}> = computed<{}>(() => store.state.isDisplay)
            let opacityStyle: ComputedRef<{}> = computed<{}>(() => store.state.opacityStyle)
            watch([dataInfo, isDisplay, opacityStyle],(data: any) => {
                const {isAccident, isFire, isWater, reportConfigInfo} = data[0]
                const {isDisplay} = data[1]
                const {opacityStyle} = data[2]
                state.reportCode = `${query.reportCode}`;
                // state.channelType = `${query.channelType}` || '';
                state.reportLevel = Number(`${query.reportLevel}`) || 0;
                state.logoUrl = reportConfigInfo ? reportConfigInfo.logoUrl : '';
                state.checkTitle = reportConfigInfo ? reportConfigInfo.checkTitle : '';
                state.isNoDefect = computed(() => {
                    return isAccident === 0 && isFire === 0 && isWater === 0
                })
                state.point = computed(() => {
                    return state.isNoDefect ? 'N' : 'Y'
                })
                state.isAccident = isAccident
                state.isFire = isFire
                state.isWater = isWater
                state.isCeilingLamp = computed(() => {
                    return isAccident === 0 && isFire === 0 && isWater === 0 && isDisplay
                })
                state.isActive = (opacityStyle && opacityStyle > 0.5) ? true : false
                if (opacityStyle) {
                    state.opacityStyle = opacityStyle
                } else {
                    state.opacityStyle = 0
                }
            })
            return {
                state
            }
        },
        methods: {
            handleClick(status: string){
                if(status === "major") {
                    this.state.clickData = this.state.titleDataMajor
                    this.state.isShowModel = true
                    document.body.style.overflow = "hidden" 
                } else if(status == 'fire') {
                    this.state.clickData = this.state.titleDataFire
                    this.state.isShowModel = true
                    document.body.style.overflow = "hidden" 
                } else if(status == 'water') {
                    this.state.clickData = this.state.titleDataWater
                    this.state.isShowModel = true
                    document.body.style.overflow = "hidden" 
                } else {
                    this.state.isShowModel = false
                }
            },
            parEvn(){
                this.state.isShowModel = false
                document.body.style.overflow = "" 
            }
        },
        components: {
            componentModel
        }
    })
